var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: { incrustation: "fa-mobile-phone", backPath: "/devices/list" },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.pageTitle))])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "full-height" }, [
        _c("div", { staticClass: "row justify-content-center full-height" }, [
          _c(
            "div",
            { staticClass: "col-6 col-xl-4" },
            [
              _c("UiCard", [
                _c(
                  "form",
                  { staticClass: "form full-height p-0" },
                  [
                    _c("div", { staticClass: "form-row row" }, [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("device.name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.device.name,
                            expression: "device.name",
                          },
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "form-input col",
                        attrs: {
                          type: "text",
                          name: "name",
                          "data-vv-rules": "required",
                          "data-vv-as": _vm.$t("device.name"),
                        },
                        domProps: { value: _vm.device.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.device, "name", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showErrors["name"] &&
                                _vm.errors.has("name"),
                              expression:
                                "showErrors['name'] && errors.has('name')",
                            },
                          ],
                          staticClass: "form-input-error",
                          on: {
                            click: function ($event) {
                              return _vm.hideError("name")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.errors.first("name")))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-select-groups",
                            expression: "'beepiz-select-groups'",
                          },
                        ],
                        staticClass: "form-row row",
                      },
                      [
                        _c(
                          "label",
                          { staticClass: "h-auto align-items-start col-4" },
                          [_vm._v(_vm._s(_vm.$t("device.groupSelect")))]
                        ),
                        _vm._v(" "),
                        _vm.groups.length > 0
                          ? _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.device.groupId,
                                    expression: "device.groupId",
                                  },
                                ],
                                staticClass: "form-input col",
                                attrs: {
                                  disabled: !_vm.useDvFlagAccess(
                                    "beepiz-group-can:update"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.device,
                                      "groupId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("device.noGroup"))),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.groups, function (group) {
                                  return _c(
                                    "option",
                                    { domProps: { value: group.id } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(group.name) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.groups.length == 0
                          ? _c("div", { staticClass: "form-label col" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("device.noGroup")) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasAnalytic
                      ? _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("device.registrations.analyticCode")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.device.analyticCode,
                                expression: "device.analyticCode",
                              },
                            ],
                            staticClass: "form-input col",
                            attrs: {
                              type: "text",
                              maxlength: "30",
                              name: "name",
                            },
                            domProps: { value: _vm.device.analyticCode },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.device,
                                  "analyticCode",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasPlanning
                      ? _c("div", { staticClass: "form-row row" }, [
                          _c(
                            "label",
                            { staticClass: "h-auto align-items-start col-4" },
                            [_vm._v(_vm._s(_vm.$t("device.planning")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-label col multiline" },
                            _vm._l(_vm.plannings, function (planning) {
                              return _c(
                                "div",
                                { staticClass: "link" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/parameters/planning/" + planning.id,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(planning.label) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasPatrol
                      ? _c("div", { staticClass: "form-row row" }, [
                          _c(
                            "label",
                            { staticClass: "h-auto align-items-start col-4" },
                            [_vm._v(_vm._s(_vm.$t("device.patrol")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-label col multiline" },
                            _vm._l(_vm.patrols, function (patrol) {
                              return _c(
                                "div",
                                { staticClass: "link" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/patrols/" + patrol.id,
                                        title:
                                          "Cliquer ici pour consulter la ronde",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(patrol.label) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isRmProvidable
                      ? _c("div", { staticClass: "form-row row" }, [
                          _c(
                            "label",
                            { staticClass: "h-auto align-items-start col-4" },
                            [_vm._v(_vm._s(_vm.$t("device.remoteMonitoring")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-label col multiline" },
                            [
                              _c("MonitoringStatus", {
                                attrs: {
                                  rmprocedures: _vm.device.rmprocedures,
                                  rmStatus: _vm.device.rmStatus,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row light" }, [
                      _c(
                        "label",
                        { staticClass: "h-auto align-items-start col-4" },
                        [_vm._v(_vm._s(_vm.$t("device.license")))]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "form-label col",
                        domProps: {
                          innerHTML: _vm._s(_vm.renderLicenceNumber),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row light" }, [
                      _c(
                        "label",
                        { staticClass: "h-auto align-items-start col-4" },
                        [_vm._v(_vm._s(_vm.$t("device.mobile")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-label col",
                          class: { multiline: _vm.device.slot2PhoneNumber },
                        },
                        [
                          _vm.device.slot1PhoneNumber
                            ? _c("span", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.device.slot1PhoneNumber)),
                                ]),
                                _vm._v(" "),
                                _vm.device.slot1SimCarrier
                                  ? _c("span", { staticClass: "text-xs" }, [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.device.slot1SimCarrier) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.device.slot2PhoneNumber
                            ? _c("span", [
                                _c("br"),
                                _c("span", { staticClass: "text-mono" }, [
                                  _vm._v(_vm._s(_vm.device.slot2PhoneNumber)),
                                ]),
                                _vm._v(" "),
                                _vm.device.slot2SimCarrier
                                  ? _c("span", { staticClass: "text-xs" }, [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.device.slot2SimCarrier) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row light" }, [
                      _c(
                        "label",
                        { staticClass: "h-auto align-items-start col-4" },
                        [_vm._v(_vm._s(_vm.$t("device.model")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-label col" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.device.deviceManufacturer
                              )
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(_vm.device.deviceModel)
                            ) +
                            "\n              "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row light" }, [
                      _c(
                        "label",
                        { staticClass: "h-auto align-items-start col-4" },
                        [_vm._v(_vm._s(_vm.$t("device.os")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-label col" }, [
                        _vm._v(_vm._s(_vm.osString)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row row light" }, [
                      _c(
                        "label",
                        { staticClass: "h-auto align-items-start col-4" },
                        [_vm._v(_vm._s(_vm.$t("device.appversion")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-label col text-mono" }, [
                        _vm._v(_vm._s(_vm.device.version)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.device.accessories, function (value, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "mb-3" },
                        [
                          _c("Accessory", {
                            attrs: {
                              accessoryType: index,
                              accessoryData: value,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 col-xl-8", staticStyle: { height: "100%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "row bottom-border realtime-infos justify-content-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col card watching d-flex mb-4",
                      class: { active: _vm.realtimeInfos.watching.active },
                      staticStyle: { "background-color": "transparent" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-inner d-flex gap-3 p-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "left-item play-pause rounded-sm" },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.realtimeInfos.watching.active
                                  ? "fa-play"
                                  : "fa-pause",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "infos flex-grow-1" }, [
                            _c("div", { staticClass: "mb-1 font-medium" }, [
                              _vm.realtimeInfos.watching.active
                                ? _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "device.realtime.watchingSince"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.watchingTime)),
                                    ]),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("device.realtime.notWatching")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _vm.realtimeInfos.watching.offlineZoneDeadline &&
                            _vm.device.offer != 57
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center gap-2 mb-2",
                                  },
                                  [
                                    _c(
                                      "DeviceRealtimeStatus",
                                      { attrs: { status: "info" } },
                                      [
                                        _c("i", {
                                          staticClass: "beepiz-offline-zone-in",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.realtimeInfos.watching
                                      .offlineZoneDeadline
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "offline-infos text-info-700",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "device.realtime.offlineZoneDeadline"
                                                )
                                              ) + "\n                    "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.watchingOfflineZoneDeadline
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.realtimeInfos.watching.active &&
                            _vm.device.offer != 57
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "d-flex",
                                    staticStyle: { gap: "0.5rem" },
                                  },
                                  [
                                    _c(
                                      "DeviceRealtimeStatus",
                                      {
                                        attrs: {
                                          status: _vm.realtimeInfos.watching
                                            .alerts.verticality
                                            ? "active"
                                            : "inactive",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "beepiz-verticality",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "DeviceRealtimeStatus",
                                      {
                                        attrs: {
                                          status: _vm.realtimeInfos.watching
                                            .alerts.immo
                                            ? "active"
                                            : "inactive",
                                        },
                                      },
                                      [_c("i", { staticClass: "beepiz-immo" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "DeviceRealtimeStatus",
                                      {
                                        attrs: {
                                          status: _vm.realtimeInfos.watching
                                            .alerts.fall
                                            ? "active"
                                            : "inactive",
                                        },
                                      },
                                      [_c("i", { staticClass: "beepiz-fall" })]
                                    ),
                                    _vm._v(" "),
                                    _vm.device &&
                                    _vm.device.temporaryWatchmen &&
                                    !!_vm.device.temporaryWatchmen.length
                                      ? _c(
                                          "DeviceRealtimeStatus",
                                          {
                                            attrs: {
                                              status: "info",
                                              title: _vm.$t(
                                                "temporary_watchman.profil_realtime_title"
                                              ),
                                            },
                                          },
                                          [
                                            _c("i", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.iconTempWatchman
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.device.accessories,
                                      function (item, index) {
                                        return _c(
                                          "DeviceRealtimeStatus",
                                          {
                                            key: index,
                                            attrs: {
                                              status: "info",
                                              title: _vm
                                                .Utils()
                                                .getAccessoryInformation(index)
                                                .label,
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "size-6 do-svg-full",
                                              attrs: {
                                                title: _vm
                                                  .Utils()
                                                  .getAccessoryInformation(
                                                    index
                                                  ).label,
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm
                                                    .Utils()
                                                    .getAccessoryInformation(
                                                      index
                                                    ).logo
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.device.offer != 57
                            ? _c(
                                "div",
                                { staticClass: "right-item battery-info" },
                                [
                                  _vm.realtimeInfos.watching.active
                                    ? _c("div", { staticClass: "battery" }, [
                                        _c(
                                          "div",
                                          { staticClass: "battery-inner" },
                                          [
                                            _c("div", {
                                              style: _vm.getBatteryHeightStyle,
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "text-mono",
                                                style:
                                                  _vm.getBatteryBottomStyle,
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    this.realtimeInfos.watching
                                                      .battery
                                                  ) + "%"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.realtimeInfos.identification != null
                    ? _c("div", { staticClass: "col-4" }, [
                        _c("div", { staticClass: "card identification" }, [
                          _c("div", { staticClass: "left-item user" }, [
                            _vm.realtimeInfos.identification != null
                              ? _c("img", {
                                  attrs: { src: _vm.identificationPic },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infos" }, [
                            _vm.realtimeInfos.identification != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "device.realtime.identification.usedBy"
                                      )
                                    )
                                  ),
                                  _c("br"),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.realtimeInfos.identification.name
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.realtimeInfos.identification == null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "device.realtime.identification.noIdentification"
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("UiCard", [
                _c("div", { staticClass: "filter-config" }, [
                  _c("div", [
                    _c("h2", { staticClass: "tw-mb-4" }, [
                      _c("i", { staticClass: "fa fa-cogs" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("device.profile")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "beepiz-select-profiles",
                            expression: "'beepiz-select-profiles'",
                          },
                        ],
                        staticClass: "profile-select width-full",
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "can",
                                rawName: "v-can",
                                value: "beepiz-edit-devices",
                                expression: "'beepiz-edit-devices'",
                              },
                            ],
                            on: { click: _vm.toggleProfileList },
                          },
                          [
                            _c("i", { staticClass: "fa fa-caret-down" }),
                            _vm._v(" "),
                            _c("i", {
                              directives: [
                                {
                                  name: "can",
                                  rawName: "v-can",
                                  value: "beepiz-edit-profiles",
                                  expression: "'beepiz-edit-profiles'",
                                },
                              ],
                              staticClass: "fa fa-eye fa-pull-right",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.showProfile(_vm.profileDef)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.profileDef.profileId
                              ? [
                                  _c("i", {
                                    staticClass: "fa fa-fw profile-icon",
                                    class: _vm.profileDef.meta.icon,
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.profileDef.meta.name) +
                                      "\n                  "
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.profileDef.profileId
                              ? [
                                  _c("i", {
                                    staticClass: "fa fa-fw profile-icon",
                                    staticStyle: { visibility: "hidden" },
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("device.noProfile")) +
                                      "\n                  "
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "on-clickaway",
                                rawName: "v-on-clickaway",
                                value: _vm.closeProfileList,
                                expression: "closeProfileList",
                              },
                              {
                                name: "can",
                                rawName: "v-can",
                                value: "beepiz-edit-devices",
                                expression: "'beepiz-edit-devices'",
                              },
                            ],
                            staticClass: "profile-select-values",
                            class: { show: _vm.showProfileList },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "profile-select-values-inner" },
                              _vm._l(_vm.profiles, function (profile) {
                                return profile.profileId !=
                                  _vm.profileDef.profileId
                                  ? _c(
                                      "div",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleChangeProfile(
                                              profile
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "can",
                                              rawName: "v-can",
                                              value: "beepiz-edit-profiles",
                                              expression:
                                                "'beepiz-edit-profiles'",
                                            },
                                          ],
                                          staticClass: "fa fa-eye",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.showProfile(profile)
                                            },
                                          },
                                        }),
                                        _c("i", {
                                          staticClass: "fa fa-fw profile-icon",
                                          class: profile.meta.icon,
                                        }),
                                        _vm._v(
                                          _vm._s(profile.meta.name) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "beepiz-add-profiles",
                                    expression: "'beepiz-add-profiles'",
                                  },
                                ],
                                staticClass: "profile-select-new",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleNewProfile()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-fw profile-icon fa-plus",
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("device.newProfile")) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tw-px-12 tw-mt-12 tw-mb-8" },
                    [
                      _c("FilterField", {
                        staticClass: "width-full",
                        on: { filter: _vm.onFilter },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: {
                      height: "calc(100% - 165px)",
                      filter: "grayscale(0.125)",
                    },
                  },
                  [
                    _c("div", { staticClass: "col scroll config-col" }, [
                      _c(
                        "div",
                        { staticClass: "tw-pt-2 tw-px-2" },
                        [
                          _vm.device.profile
                            ? _c("Config", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "beepiz-read-profiles",
                                    expression: "'beepiz-read-profiles'",
                                  },
                                ],
                                staticStyle: { "pointer-events": "none" },
                                attrs: {
                                  config: _vm.profileDef.config,
                                  filterStr: _vm.filterStr,
                                  version: _vm.device.version,
                                  datiOffer: _vm.device.offer,
                                  readonly: true,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.device.profile
                            ? _c("div", { staticClass: "no-profile" }, [
                                _c("i", {
                                  staticClass: "fa fa-exclamation-triangle",
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("device.noProfileMessage")
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex gap-2 tw-py-4 bg-gray-50 mt-3 px-2",
          staticStyle: {
            position: "sticky",
            bottom: "0",
            "z-index": "2",
            "margin-left": "-0.5rem",
            "margin-right": "-0.5rem",
          },
        },
        [
          _vm.device.offer != 57
            ? _c(
                "Btn",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-delete-devices",
                      expression: "'beepiz-delete-devices'",
                    },
                  ],
                  class: "primary danger pull-left",
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleDeassoc($event)
                    },
                  },
                },
                [
                  _c("span", [
                    _c("i", { staticClass: "fa fa-unlink" }),
                    _vm._v(" " + _vm._s(_vm.$t("device.btns.deassoc"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: _vm.getReportRoute, tag: "span" } },
            [
              _c("Btn", { class: "default pull-left" }, [
                _c("i", { staticClass: "fa fa-file" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("device.btns.goToReport")) + "\n      "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1" }),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: "/devices/list", tag: "span" } },
            [
              _c("Btn", { class: "pull-right" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.cancel"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-devices",
                  expression: "'beepiz-edit-devices'",
                },
              ],
              class: ["primary pull-right"],
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.validForm($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("global.save")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }